import { RundotApiError } from '../errors'
import { utf8ByteLength } from '../utils/utf8'

// Mirrors server/cloud-run/src/services/playerStorage.service.ts (validateKey /
// validateValue) and STORAGE_LIMITS in server/cloud-run/src/types/playerStorage.ts.
// Keep these constants/rules in sync with that server source of truth.
const MAX_KEY_BYTES = 256
const MAX_VALUE_BYTES = 1_000_000
const MAX_BATCH_ITEMS = 400
const MAX_MULTI_GET_KEYS = 100
const METADATA_PREFIX = '__'
const LEGACY_METADATA_FIELDS = new Set<string>(['lastUpdated'])

export function validateStorageKey(key: string): void {
  if (typeof key !== 'string' || key.length === 0) {
    throw new RundotApiError('INVALID_ARGUMENT', 'Key must be a non-empty string', 400)
  }
  if (utf8ByteLength(key) > MAX_KEY_BYTES) {
    throw new RundotApiError('INVALID_ARGUMENT', `Key exceeds maximum size of ${MAX_KEY_BYTES} bytes`, 400)
  }
  if (key.includes('.')) {
    throw new RundotApiError('INVALID_ARGUMENT', 'Key must not contain "."', 400)
  }
  if (key.startsWith(METADATA_PREFIX)) {
    throw new RundotApiError('INVALID_ARGUMENT', `Key must not start with "${METADATA_PREFIX}"`, 400)
  }
  if (LEGACY_METADATA_FIELDS.has(key)) {
    throw new RundotApiError('INVALID_ARGUMENT', `Key "${key}" is reserved`, 400)
  }
}

export function validateStorageValue(value: string): void {
  if (typeof value !== 'string') {
    throw new RundotApiError('INVALID_ARGUMENT', 'Value must be a string', 400)
  }
  const byteLength = utf8ByteLength(value)
  if (byteLength > MAX_VALUE_BYTES) {
    throw new RundotApiError(
      'PAYLOAD_TOO_LARGE',
      `Value of ${byteLength} bytes exceeds maximum size of ${MAX_VALUE_BYTES} bytes`,
      413,
    )
  }
}

export function validateStorageBatchSize(itemCount: number): void {
  if (itemCount > MAX_BATCH_ITEMS) {
    throw new RundotApiError('INVALID_ARGUMENT', `Batch exceeds maximum item count of ${MAX_BATCH_ITEMS}`, 400)
  }
}

export function validateStorageMultiGetSize(keyCount: number): void {
  if (keyCount > MAX_MULTI_GET_KEYS) {
    throw new RundotApiError('INVALID_ARGUMENT', `Multi-get exceeds maximum key count of ${MAX_MULTI_GET_KEYS}`, 400)
  }
}
